/**
 * Copy of https://github.com/danshaman05/finnish-ssn-2/blob/master/src/finnish-ssn.ts
 * Adds fix for daily counter which should be 002-999
 */
export class FinnishSSN {
    static FEMALE = 'female';
    static MALE = 'male';
    /**
     * Parse parameter given SSN string into Object representation.
     * @param ssn - {String} SSN to parse
     * @param today - {Date} Optional today date, primarily for testing
     */
    static parse(ssn, today) {
        //  Sanity and format check, which allows to make safe assumptions on the format.
        if (!SSN_REGEX.test(ssn)) {
            throw new Error('Not valid SSN format');
        }
        const dayOfMonth = parseInt(ssn.substring(0, 2), 10);
        const month = ssn.substring(2, 4);
        const centuryId = ssn.charAt(6);
        const century = centuryMap.get(centuryId); // can be safely cast since verified in initial format check
        const year = parseInt(ssn.substring(4, 6), 10) + century;
        const rollingId = ssn.substring(7, 10);
        const rollingIdAsNumber = parseInt(rollingId, 10);
        const checksum = ssn.substring(10, 11);
        const sex = rollingIdAsNumber % 2 ? this.MALE : this.FEMALE;
        const daysInMonth = daysInGivenMonth(year, month);
        if (!daysInMonths[month] || dayOfMonth > daysInMonth) {
            throw new Error('Not valid SSN');
        }
        const validRollingId = rollingIdAsNumber >= 2 && rollingIdAsNumber <= 999;
        const checksumBase = parseInt(ssn.substring(0, 6) + rollingId, 10);
        const dateOfBirth = new Date(year, parseInt(month, 10) - 1, dayOfMonth, 0, 0, 0, 0);
        const todaysDate = today || new Date();
        return {
            valid: checksum === checksumTable[checksumBase % 31] && validRollingId,
            sex,
            dateOfBirth,
            ageInYears: ageInYears(dateOfBirth, todaysDate),
        };
    }
    /**
     * Validates parameter given SSN. Returns true if SSN is valid, otherwise false.
     * @param ssn - {String} For example '010190-123A'
     */
    static validate(ssn) {
        try {
            return this.parse(ssn).valid;
        }
        catch {
            return false;
        }
    }
    static isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }
}
const centuryMap = new Map();
centuryMap.set('A', 2000);
centuryMap.set('B', 2000);
centuryMap.set('C', 2000);
centuryMap.set('D', 2000);
centuryMap.set('E', 2000);
centuryMap.set('F', 2000);
centuryMap.set('-', 1900);
centuryMap.set('U', 1900);
centuryMap.set('V', 1900);
centuryMap.set('W', 1900);
centuryMap.set('X', 1900);
centuryMap.set('Y', 1900);
centuryMap.set('+', 1800);
var Month;
(function (Month) {
    Month["JANUARY"] = "01";
    Month["FEBRUARY"] = "02";
    Month["MARCH"] = "03";
    Month["APRIL"] = "04";
    Month["MAY"] = "05";
    Month["JUNE"] = "06";
    Month["JULY"] = "07";
    Month["AUGUST"] = "08";
    Month["SEPTEMBER"] = "09";
    Month["OCTOBER"] = "10";
    Month["NOVEMBER"] = "11";
    Month["DECEMBER"] = "12";
})(Month || (Month = {}));
const daysInMonths = {
    [Month.JANUARY]: 31,
    [Month.FEBRUARY]: 28,
    [Month.MARCH]: 31,
    [Month.APRIL]: 30,
    [Month.MAY]: 31,
    [Month.JUNE]: 30,
    [Month.JULY]: 31,
    [Month.AUGUST]: 31,
    [Month.SEPTEMBER]: 30,
    [Month.OCTOBER]: 31,
    [Month.NOVEMBER]: 30,
    [Month.DECEMBER]: 31,
};
const checksumTable = '0123456789ABCDEFHJKLMNPRSTUVWXY'.split('');
const SSN_REGEX = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])(\d\d)(\+|-|[A-F]|[YXVWU])\d{3}[\dA-Z]$/;
function daysInGivenMonth(year, month) {
    const daysInMonth = daysInMonths[month];
    return month === Month.FEBRUARY && FinnishSSN.isLeapYear(year)
        ? daysInMonth + 1
        : daysInMonth;
}
function ageInYears(dateOfBirth, today) {
    return (today.getFullYear() -
        dateOfBirth.getFullYear() -
        (birthDayPassed(dateOfBirth, today) ? 0 : 1));
}
function birthDayPassed(dateOfBirth, today) {
    return (dateOfBirth.getMonth() < today.getMonth() ||
        (dateOfBirth.getMonth() === today.getMonth() &&
            dateOfBirth.getDate() <= today.getDate()));
}
//# sourceMappingURL=finnish-ssn.js.map